import { render } from "./emailDashboard.vue?vue&type=template&id=7021897a"
import script from "./emailDashboard.vue?vue&type=script&lang=js"
export * from "./emailDashboard.vue?vue&type=script&lang=js"

import "./emailDashboard.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__